export default __webpack_public_path__ + "static/media/regulatory--maximum-speed-limit-led-35--g3.ad302825.png";